import { Grid } from "@mui/material";
import {
  useEffect,
  useRef,
  // useState
} from "react";
import Slider, { type Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CardsCarousel.css";
import { LandingPageCard } from "pages/start/LandingPageCard";

export interface CardCarouselAttribute {
  key: string;
  boxName: string;
  bgImage: string;
  boxColorBg: string;
  boxContentTitle: string;
  boxContentText: string;
  btnActionName: string;
  urlAction: string;
}

interface CardsCarouselProps {
  cards: CardCarouselAttribute[];
  settings?: Settings;
  goToSlide?: number;
  isLogin?: boolean;
  t: (key: string) => string;
}

export const CardsCarousel = ({
  cards,
  settings,
  goToSlide,
  isLogin = false,
  t,
}: CardsCarouselProps) => {
  const sliderRef = useRef<Slider | null>(null);

  const defaultSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    ...settings,
  };

  useEffect(() => {
    if (goToSlide !== undefined) {
      sliderRef.current?.slickGoTo(goToSlide);
    }
  }, [goToSlide]);
  return (
    <Grid
      container
      columns={1}
      spacing={3}
      className="cards-carousel-container"
    >
      <Slider
        ref={(slider) => (sliderRef.current = slider)}
        {...defaultSettings}
      >
        {cards.map((card) => (
          <LandingPageCard
            data-cy={card.key}
            key={card.key}
            boxName={t(card.boxName)}
            bgImage={card.bgImage}
            boxColorBg={card.boxColorBg}
            boxContentTitle={t(card.boxContentTitle)}
            boxContentText={t(card.boxContentText)}
            btnActionName={t(card.btnActionName)}
            urlAction={card.urlAction}
            isLogin={isLogin}
          />
        ))}
      </Slider>
    </Grid>
  );
};
